import { Reveal, SectionHead, Crosshair } from "./Reveal";
import { useLang } from "../../i18n/LanguageContext";

export const Manifesto = () => {
  const { t } = useLang();
  return (
    <section id="manifesto" className="relative bg-canvas bp-grid py-24 sm:py-32" data-testid="manifesto-section">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8">
        <SectionHead eyebrow={t.manifesto.eyebrow} title={t.manifesto.title} testid="manifesto" />
        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-px bg-[rgba(22,24,27,0.12)] border border-technical">
          {t.manifesto.chapters.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.08} className="relative bg-canvas p-8 sm:p-12 group transition-colors duration-300 hover:bg-white">
              <Crosshair className="top-3 right-3 opacity-40 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="flex items-start gap-6">
                <span className="font-mono-tech text-5xl sm:text-6xl font-bold text-[#16181b]/10 group-hover:text-red-brand transition-colors duration-300 leading-none">
                  {c.num}
                </span>
                <div>
                  <h3 className="font-display text-xl sm:text-2xl font-bold tracking-tight text-ink" data-testid={`manifesto-chapter-${c.num}`}>
                    {c.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#525964]">{c.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
